import React, {Component} from 'react';
import { ResponsiveBar } from '@nivo/bar'
import {Typography} from "@material-ui/core";

class CasesChart extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    /* -------- LIFECYCLE METHODS -------- */


    /* -------- FUNCTIONS -------- */


    /* -------- API CALLS -------- */


    /* -------- RENDERS -------- */
    renderTooltip = (props) => {
        return <div style={{
            background: 'white',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            padding: '9px 12px',
            borderRadius: '4px'
        }}>
            <Typography variant={'subtitle1'} >{props.data.province + " - Confirmed: " + Number(props.data.total).toLocaleString('en')}</Typography>
            <div style={{
                    padding: '3px 0',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'baseline'
                }}>
                <svg width="10" height="10">
                    <rect width="9" height="9"  fill={'#FFD54F'}/>
                </svg>
                <Typography variant={'caption'} style={{marginRight: '4px', marginLeft: '4px'}}>{"Active: " + Number(props.data.Active).toLocaleString('en')}</Typography>
            </div>
            <div style={{
                padding: '3px 0',
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'baseline'
                }}>
                <svg width="10" height="10">
                    <rect width="9" height="9"  fill={'#81C784'}/>
                </svg>
                <Typography variant={'caption'} style={{marginRight: '4px', marginLeft: '4px'}}>{"Recovered: " + Number(props.data.Recovered).toLocaleString('en')}</Typography>
            </div>
            <div style={{
                padding: '3px 0',
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'baseline'
                }}>
                <svg width="10" height="10">
                    <rect width="9" height="9"  fill={'#F44336'}/>
                </svg>
                <Typography variant={'caption'} style={{marginRight: '4px', marginLeft: '4px'}}>{"Deaths: " + Number(props.data.Deaths).toLocaleString('en')}</Typography>
            </div>
        </div>
    }

    render() {
        if(!this.props.data) {
            return null
        }

        let data = []

        this.props.data.forEach(d => {
            data.push({
                "id": d.id,
                "province": d.name,
                "short_name": d.id,
                "Active": (d.confirmed - d.recovered - d.deaths),
                "Recovered": d.recovered,
                "Deaths": d.deaths,
                "total": d.confirmed
            })
        })

        data.sort((a,b) => b.total - a.total)

        let mediaBreakPoint = (this.props.dimensions[0] <= 856)

        return <div className='section'>
            <Typography variant={'h4'} align={'left'} style={{marginBottom: 8}}>Case Count by Province</Typography>
            <div style={{display: 'flex', height: 472, width: '100%', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', paddingBottom: 24}}>
                <ResponsiveBar
                    data={data}
                    keys={[ 'Active', 'Recovered', 'Deaths' ]}
                    indexBy="short_name"
                    margin={{ top: 50, right: mediaBreakPoint ? 10 : 130, bottom: 50, left: 60 }}
                    padding={0.3}
                    colors={["#FFD54F","#81C784","#F44336"]}
                    borderColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
                    axisTop={null}
                    axisRight={null}
                    axisBottom={{
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: 'Province',
                        legendPosition: 'middle',
                        legendOffset: 32
                    }}
                    axisLeft={{
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: 'Cases',
                        legendPosition: 'middle',
                        legendOffset: -48
                    }}
                    labelSkipWidth={12}
                    labelSkipHeight={12}
                    labelTextColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
                    legends={[
                        {
                            dataFrom: 'keys',
                            anchor: mediaBreakPoint ? 'top-right' : 'bottom-right',
                            direction: 'column',
                            justify: false,
                            translateX: mediaBreakPoint ? 0 : 120,
                            translateY: 0,
                            itemsSpacing: 2,
                            itemWidth: 100,
                            itemHeight: 20,
                            itemDirection: 'left-to-right',
                            itemOpacity: 0.85,
                            symbolSize: 20,
                            effects: [
                                {
                                    on: 'hover',
                                    style: {
                                        itemOpacity: 1
                                    }
                                }
                            ]
                        }
                    ]}
                    animate={true}
                    motionStiffness={90}
                    motionDamping={15}
                    tooltip={this.renderTooltip}
                />
            </div>
        </div>
    }
}

export default CasesChart